import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { ModalProvider } from './contexts/ModalContext';
import './index.css';

createRoot(document.getElementById('root')!).render(
    <BrowserRouter>
      <ModalProvider>
        <App/>
      </ModalProvider>
    </BrowserRouter>
);
